import React from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import type { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
interface Props {
  locale: LanguageCodeEnum;
}
export const BookingAgreement: React.FC<Props> = props => {
  const {
    locale
  } = props;
  const t = useTranslations();
  return <label className="flex items-center gap-2 text-base" data-sentry-component="BookingAgreement" data-sentry-source-file="BookingAgreement.tsx">
      <span>
        {t('bookingPage.accept')}{' '}
        <Link prefetch={false} lang={locale} className="text-primary underline" target="_blank" href="/agreement" data-sentry-element="Link" data-sentry-source-file="BookingAgreement.tsx">
          {t('bookingPage.public_offer')}
        </Link>
      </span>
    </label>;
};